// extracted by mini-css-extract-plugin
export default {"inputs":"form_inputs__zbXfo"};